'use strict';

var util = require('../../util/property-util');

module.exports = /*@ngInject*/ function () {
    var factory = {};
    factory.createKmlPolygons = function (polygon, color, xml) {
        polygon.forEach(function (wp) {
            xml.startElement('Placemark');
            xml.writeElement('name', wp.description);
            xml.writeElement('styleUrl', "#" + color);

            xml.startElement('Polygon');
            xml.startElement('outerBoundaryIs').startElement('LinearRing');
            xml.writeElement('coordinates', createCoordinateString(wp.getPath()));
            xml.endElement().endElement();
            xml.writeElement('altitudeMode', 'relative');
            xml.endElement(); //ends polygon
            xml.endElement(); //ends Placemark
        });
    };

    var createCoordinateString = function (path) {
        var string = "";
        var firstCoordinate = undefined;
        path.forEach(function (coordinate) {
            if (!util.isDefined(firstCoordinate)) {
                firstCoordinate = coordinate;
            }
            string += coordinate.lng() + ',' + coordinate.lat() + ',0 '
        });
        string += firstCoordinate.lng() + ',' + firstCoordinate.lat() + ',0';
        return string;
    };


    /**
     * Accepts a color (3 or 6 hex numbers) and returns a color suited for KML
     * @param color     hexcolor notation (eg. #a13 or #a135b5)
     * @returns {string}
     * @param alpha
     */
    factory.extractKmlColor = function (color, alpha) {
        var kmlColor;
        if (color.indexOf('#') == -1) {
            kmlColor = "#000"
        } else {
            kmlColor = color.substring(1, color.length);
        }
        var red = undefined, green = undefined, blue = undefined;
        if (kmlColor.length > 3) {
            red = kmlColor.substring(0, 2);
            green = kmlColor.substring(2, 4);
            blue = kmlColor.substring(4, 6);
            kmlColor = blue + "" + green + "" + red;
        } else {
            red = kmlColor.substring(0, 1);
            green = kmlColor.substring(1, 2);
            blue = kmlColor.substring(2, 3);
            kmlColor = blue + "" + blue + "" + green + "" + green + "" + red + "" + red;
        }
        if (util.isDefined(alpha)) {
            kmlColor = alpha + kmlColor;
        } else {
            kmlColor = "ff" + kmlColor;
        }
        return kmlColor;
    };

    /**
     * Create KML (xml) for a polyline
     * @param coord1    first coordinate
     * @param coord2    second coordinate
     * @param color     the color this polyline will be
     * @param value     the value that belongs to this polyline
     * @param timestamp
     * @param timestamp
     * @param xml       xml object in which this polyline-kml will be inserted
     * @param labelsXml
     * @param labelsXml
     */
    factory.createKmlPolyline = function (coord1, coord2, color, value, timestamp, xml, labelsXml) {
        var longForLabel = coord1.lng() - 0.0002;

        xml.startElement('Placemark');

        xml.writeElement('name', value + " " + timestamp);

        xml.startElement('Style').startElement('LineStyle').writeElement('color', color);
        xml.writeElement('width', 4);
        xml.endElement().endElement(); //ends LineStyle & Style
        xml.startElement('LineString');
        xml.writeElement('coordinates', coord1.lng() + ',' + coord1.lat() + ',0 ' + coord2.lng() + ',' + coord2.lat() + ',0');
        xml.writeElement('altitudeMode', 'relative');
        xml.endElement(); // ends LineString
        xml.endElement(); //ends Placemark
        // waypoint (label)
        if (util.isDefined(value)) {
            labelsXml.startElement('Placemark');
            labelsXml.writeElement('name', value + "  " + timestamp);
            labelsXml.startElement('Style').startElement('IconStyle').writeElement('scale', 0.0).endElement().endElement();
            labelsXml.startElement('Point').writeElement('coordinates', longForLabel + ',' + coord1.lat() + ',0 ');
            labelsXml.endElement(); //end Point
            createRegion(coord1, coord2, labelsXml);
            labelsXml.endElement(); //end Placemark
        }
    };

    /**
     * Creates a region with LatLonAltBox
     * prevents the placemark this region is placed in to be viewed outside the box
     * @param coord1
     * @param coord2
     * @param xml
     */
    function createRegion(coord1, coord2, xml) {
        var west = coord1.lng() < coord2.lng() ? coord1.lng() : coord2.lng();
        var east = coord1.lng() > coord2.lng() ? coord1.lng() : coord2.lng();
        var north = coord1.lat() > coord2.lat() ? coord1.lat() : coord2.lat();
        var south = coord1.lat() < coord2.lat() ? coord1.lat() : coord2.lat();

        xml.startElement('Region').startElement('LatLonAltBox');
        xml.writeElement('north', north).writeElement('south', south).writeElement('east', east).writeElement('west', west);
        xml.endElement(); //end LatLonAltBox
        xml.startElement('Lod');
        xml.writeElement('minLodPixels', 15).writeElement('maxLodPixels', 1024);
        xml.endElement().endElement();//end Lod & Region
    }

    return factory;
};
